import {
    LoggerContext, LogObject, Transform, TransformResult,
} from 'src/types';

type CircularReplacer<T> = (key: string, value: T) => undefined | T

type ValidTypes<T> = string | number | boolean | Record<string, any> | Array<T>;

const getCircularReplacer = <T extends ValidTypes<T>> (): CircularReplacer<T> => {
    const seen = new WeakSet();

    return (key: string, value: T): undefined | T => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value as Record<string, any>)) {
                return;
            }
            seen.add(value as Record<string, any>);
        }

        // eslint-disable-next-line consistent-return
        return value;
    };
};

/**
 * Double check for circular references
 */
export const circularReplacer: Transform = (
    message: LogObject,
    context: LoggerContext,
): TransformResult => ({
    context,
    message: JSON.parse(JSON.stringify(message, getCircularReplacer())),
});
